module.exports = {
  //getMerchantDetails
  FETCH_MERCHANT_DATA: "FETCH_MERCHANT_DATA",
  FETCH_BANNER_DATA: "FETCH_BANNER_DATA",
  GET_ERRORS: "GET_ERRORS",
  RESET_DASHBOARD: "RESET_DASHBOARD",
  UPDATE_NOTIFICTION_COUNT: 'UPDATE_NOTIFICTION_COUNT'
};
